import { useState } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BudgetEstimatorSection from "@/components/budget/BudgetEstimatorSection";
import WinterGuideSection from "@/components/WinterGuideSection";
import CarbonEstimatorSection from "@/components/carbon/CarbonEstimatorSection";
import LeadFormModal from "@/components/LeadGenerationForm/LeadFormModal";
import { motion } from "framer-motion";
import { Calculator, Download, Leaf } from "lucide-react";
const Tools = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [formTrigger, setFormTrigger] = useState({ location: "unknown", text: "unknown" });
  const openForm = (triggerLocation: string, triggerText: string) => {
    setFormTrigger({ location: triggerLocation, text: triggerText });
    setIsFormOpen(true);
  };
  return <div className="min-h-screen flex flex-col">
      <Header onOpenForm={() => openForm("tools-header", "Envoyer votre demande")} forceScrolled={true} />
      
      <main className="flex-1 pt-20">
        {/* Hero Section */}
        <section className="bg-background py-28 md:py-40 px-4">
          <div className="container mx-auto max-w-7xl">
            <div className="flex flex-col lg:flex-row items-center gap-12">
              <motion.div initial={{
              opacity: 0,
              x: -20
            }} animate={{
              opacity: 1,
              x: 0
            }} transition={{
              duration: 0.6
            }} className="lg:w-1/3 text-center lg:text-left">
                <h1 className="text-4xl md:text-5xl lg:text-5xl text-foreground mb-4 font-normal">
                  Nos outils
                </h1>
                <p className="text-lg md:text-xl text-muted-foreground">
                  Outils gratuits pour vous aider à planifier votre événement d'entreprise parfait
                </p>
              </motion.div>
              
              <div className="lg:w-2/3 grid md:grid-cols-3 gap-4">
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.1
              }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:border-cta-green hover:shadow-lg transition-all cursor-pointer" onClick={() => document.getElementById('budget-section')?.scrollIntoView({
                behavior: 'smooth'
              })}>
                  <div className="w-12 h-12 bg-[#C6E278] rounded-lg flex items-center justify-center mb-4">
                    <Calculator className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-gray-900">Calculateur Budget</h3>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    Estimez le budget de votre événement en quelques clics
                  </p>
                </motion.div>
                
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.2
              }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:border-cta-green hover:shadow-lg transition-all cursor-pointer" onClick={() => document.getElementById('winter-guide-section')?.scrollIntoView({
                behavior: 'smooth',
                block: 'center'
              })}>
                  <div className="w-12 h-12 bg-[#C6E278] rounded-lg flex items-center justify-center mb-4">
                    <Download className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-gray-900">Guide 2026</h3>
                  <p className="text-sm text-gray-600 line-clamp-2">Les meilleurs lieux et tendances de l'année</p>
                </motion.div>
                
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} animate={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.3
              }} className="bg-white border border-gray-200 p-6 rounded-2xl shadow-sm hover:border-cta-green hover:shadow-lg transition-all cursor-pointer" onClick={() => document.getElementById('carbon-section')?.scrollIntoView({
                behavior: 'smooth'
              })}>
                  <div className="w-12 h-12 bg-[#C6E278] rounded-lg flex items-center justify-center mb-4">
                    <Leaf className="w-6 h-6 text-black" />
                  </div>
                  <h3 className="font-semibold text-lg mb-2 text-gray-900">Calculateur Carbone</h3>
                  <p className="text-sm text-gray-600 line-clamp-2">
                    Calculez l'impact environnemental de votre événement
                  </p>
                </motion.div>
              </div>
            </div>
          </div>
        </section>

        <div id="budget-section" className="mt-10 md:mt-12">
          <BudgetEstimatorSection />
        </div>

        <div id="winter-guide-section" className="mt-10 md:mt-12">
          <WinterGuideSection />
        </div>

        <div id="carbon-section" className="mt-10 md:mt-12 pb-16 md:pb-20 bg-gray-100">
          <CarbonEstimatorSection />
        </div>
      </main>

      <Footer />
      <LeadFormModal isOpen={isFormOpen} onClose={() => setIsFormOpen(false)} triggerLocation={formTrigger.location} triggerText={formTrigger.text} />
    </div>;
};
export default Tools;